import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faFilter,
  faPlus,
  faRecycle,
  faTrash,
  faUserGroup,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import PageTitle from '../../components/page-title/index';
import Layout from '../../components/layout/base/index';

import { LoggedUserContext } from '../../contexts/logged-user-context';

import OwnerTeams from './owner-teams';
import MemberTeams from './member-teams';

import EquipeService from '../../services/equipe-service';

import lib from '../../helpers/lib';

import './styles.scss';
import PageTitleCard from 'components/page-title-card';

export default function Time() {
  const [userData, _] = React.useContext(LoggedUserContext);

  const ownerTeamsRef = useRef();

  const handleNewTeam = () => {
    ownerTeamsRef.current?.add();
  };

  return (
    <Layout>
      <PageTitleCard title="Meus Times" icon={<FontAwesomeIcon icon={faUsers} />}>
        {userData?.cadastraEquipe && (
          <button
            type="button"
            className="btn btn-secondary d-flex align-items-center"
            onClick={handleNewTeam}
          >
            <FontAwesomeIcon icon={faPlus} className="icon" />{' '}
            <span className="ms-2">Novo Time</span>
          </button>
        )}
      </PageTitleCard>

      {userData?.cadastraEquipe && (
        <>
          <OwnerTeams ref={ownerTeamsRef} />
          <hr />
        </>
      )}

      <MemberTeams />
    </Layout>
  );
}
